import { Toaster as Sonner, toast } from "sonner"
import { Check, Info, TriangleAlert, CircleAlert, Loader2 } from "lucide-react"

const GOLD = "#B5A36A"
const icon = (Icon, extra = "") => <Icon className={`w-4 h-4 ${extra}`} style={{ color: GOLD }} strokeWidth={2} aria-hidden="true" />

// Ordinary success confirmations default to ~3s; explicit durations at call sites still win.
const baseSuccess = toast.success
toast.success = (message, options) => baseSuccess(message, { duration: 3000, ...options })

// Shared ivory/antique-gold notification theme (always light, no rich colours); distinct icon per type.
const Toaster = (props) => (
  <Sonner
    theme="light"
    className="toaster group"
    style={{ "--normal-bg": "#FAF8F2", "--normal-border": GOLD, "--normal-text": "#142235", "--border-radius": "10px" }}
    icons={{
      success: icon(Check),
      info: icon(Info),
      warning: icon(TriangleAlert),
      error: icon(CircleAlert),
      loading: icon(Loader2, "animate-spin"),
    }}
    {...props} />
)

export { Toaster, toast }
